import React, { memo, useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '../../../assets/icons/search.svg';
import './input.scss';
export var useDebounce = function (value, delay) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () { return clearTimeout(handler); }; // Xóa bộ đếm thời gian nếu giá trị thay đổi
    }, [value, delay]);
    return debouncedValue;
};
export var InputGroup = function (props) {
    var classes = useStyle();
    var theme = useTheme();
    var iconName = props.iconName, placeholder = props.placeholder, value = props.value, onChange = props.onChange, type = props.type;
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && props.onPressEnter) {
            props.onPressEnter(event);
        }
    };
    return (React.createElement("div", { className: "input-group" },
        React.createElement("div", { className: "input-group-icon" }, iconName ? React.createElement(Icon, null, iconName) : "@"),
        React.createElement("div", { className: "input-group-area" },
            React.createElement("input", { type: type, onKeyDown: handleKeyDown, placeholder: placeholder ? placeholder : "", value: value, onChange: function (val) { return onChange && onChange(val.currentTarget.value || ""); } }))));
};
export var InputIcon = function (props) {
    var iconName = props.iconName, placeholder = props.placeholder, value = props.value, onChange = props.onChange, type = props.type;
    return (React.createElement("form", { className: "panel-ctrls-center panel-heading-search-input-wrapper" },
        React.createElement("div", { className: "input-icon right" },
            iconName ? React.createElement(Icon, null, iconName) : "@",
            React.createElement("input", { type: type, className: "form-control", placeholder: placeholder ? placeholder : "", value: value, onChange: onChange }))));
};
export var InputGroupTextIcon = function (props) {
    var classes = useStyle();
    var theme = useTheme();
    var iconName = props.iconName, placeholder = props.placeholder, textExtend = props.textExtend;
    return (React.createElement("div", { className: "input-group" },
        React.createElement("div", { className: "input-group-icon" }, textExtend),
        React.createElement("div", { className: "input-group-area" },
            React.createElement("input", { type: "text", placeholder: placeholder ? placeholder : "" })),
        React.createElement("div", { className: "input-group-icon" },
            React.createElement(Icon, null, iconName))));
};
export var InputSearchIcon = function (props) {
    var iconName = props.iconName, placeholder = props.placeholder, value = props.value, onChange = props.onChange, type = props.type, className = props.className;
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && props.onPressEnter) {
            props.onPressEnter(event);
        }
    };
    return (React.createElement("form", { className: "panel-ctrls-center panel-heading-search-publisher-input-wrapper" + (className ? ' ' + className : '') },
        React.createElement("div", { className: "input-icon-search right" },
            React.createElement("img", { className: "icon-search", src: SearchIcon }),
            React.createElement("input", { type: type, className: "form-control", placeholder: placeholder ? placeholder : "", value: value, onChange: onChange, onKeyDown: handleKeyDown }))));
};
export var InputMaterial = memo(function (props) {
    var value = props.value, setter = props.setter, text = props.text, type = props.type, multiline = props.multiline, onChange = props.onChange, placeholder = props.placeholder;
    var handleChange = function (e) {
        var inputValue = e.target.value;
        setter(inputValue);
        onChange(inputValue);
    };
    return (React.createElement(Grid, null,
        React.createElement(TextField, { fullWidth: true, type: type ? type : "text", label: text ? text : "", value: value, placeholder: placeholder ? placeholder : "", onChange: handleChange, multiline: multiline })));
});
var useStyle = makeStyles(function (theme) { return ({}); });
export var NormalInput = function (props) {
    var placeholder = props.placeholder, value = props.value, onChange = props.onChange, type = props.type, className = props.className;
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && props.onPressEnter) {
            props.onPressEnter(event);
        }
    };
    return (React.createElement("div", { className: "normal-input-wrapper" + (className ? " " + className : '') },
        React.createElement("input", { type: type, className: "form-control", placeholder: placeholder ? placeholder : "", value: value, onChange: onChange, onKeyDown: handleKeyDown })));
};
